import { FC } from 'react';

import ProductIngredientListing from 'components/main/ProductIngredient';

const ProductIngredient: FC = () => <ProductIngredientListing />;

export default ProductIngredient;
